<div class="container--padding">
  <h2 class="mt-5">{{ "QR codes" | translate }}</h2>
  <br />
  <div class="qr--box" *ngIf="!showQR">
    <div class="row">
      <div class="col-lg-7 img--top">
        <img class="about__qr--img" src="/assets/images/QR_codes.svg" />
      </div>
      <div class="col-lg-5">
        <h2 class="qr--box--title">
          {{ "I’m new to QR codes. What should  I know?" | translate }}
        </h2>
        <p>{{ "AboutQR" | translate }}</p>
        <button
          type="button"
          class="button button--purple button--big"
          (click)="generateQr()"
        >
          <span>{{ "Generate QR" | translate }}</span>
        </button>
      </div>
      <div
        class="col-lg-7 d-flex justify-content-center align-items-center img--bottom"
      >
        <img class="about__qr--img" src="/assets/images/QR_codes.svg" />
      </div>
    </div>
  </div>
  <div class="qr--box" *ngIf="showQR">
    <div class="row">
      <div class="col">
        <h2 class="qr--box--title">
          {{ "Your personal QR code" | translate }}
        </h2>
        <p>{{ "AboutPersonalQR" | translate }}</p>
      </div>
      <div class="col text-align--center">
        <img
          class="qr--img"
          src="https://www.kaspersky.ru/content/ru-ru/images/repository/isc/2020/9910/a-guide-to-qr-codes-and-how-to-scan-qr-codes-2.png"
        />

        <div class="text-align--center">
          <button
            type="button"
            class="button button--purple button--big"
            (click)="downloadQr()"
          >
            <span>{{ "Download" | translate }}</span>
          </button>
        </div>
      </div>
    </div>
  </div>
</div>
